import React from 'react';
import { connect } from "react-redux";

import { Route } from 'react-router';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import StrokeSend from '../icons/StrokeModifiedSend';
import StrokeCancel from '../icons/StrokeCancel';
import GlyphSmallCancel from '../icons/GlyphSmallCancel';
import '../css/SelectedActions.css'

import SendPage from '../send/SendPageContainer';

const styles = {
  bar: {
    background: '#F0F6FA',
    borderColor: '#CFE0E2',
    color: '#59595A'
  },
  count: {
    backgroundColor: '#69C4CD',
    color: '#F9FAFB',
    width: '38px',
    height: '38px'
  },
  countNumber: {
    //top: '50%',
    top: '45.5%',
    left: '49.5%',
    transform: 'translate(-50%, -50%)'
  },
  size: {
    color: '#A4BFCC'
  }
}

const classes = {
  svg: (v) => v ? 'w3 pointer hover-fill-navy-muted' : 'w3',
  action: (v) => v ? 'pointer' : 'disabled o-20'
}

class SelectedActions extends React.Component {
  constructor (props) {
    super(props)
    this.containerRef = React.createRef()
  }

  static propTypes = {
    send: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    animateOnStart: PropTypes.bool
  }

  static defaultProps = {
    className: ''
  }

  state = {
    force100: false
  }

  componentDidMount () {
    this.containerRef.current && this.containerRef.current.focus()
  }

  render () {
    const { animateOnStart, count, unselect, send, cancel, multipleCanceling, className, style, ...props } = this.props

    const isSingle = count === 1

    let singleFileTooltip = { title: 'individualFilesOnly' }

    if (count === 1) {
      singleFileTooltip = {}
    }

    return (
      <div className={classNames('times-new-roman bt w-100 pa3 ph4-l', className, animateOnStart && 'selectedActionsAnimated')} style={{ ...styles.bar, ...style, maxWidth: '100%' }} {...props}>
        <div className='flex items-center justify-between'>
          <div className='w5-l'>
            <div className='flex items-center'>
               <div className='mr3 relative f3 fw6 flex-shrink-0 dib br-100' style={styles.count}>
                 <span className='absolute' style={styles.countNumber}>{count}</span>
               </div>
               <div className='dn db-l f6'>
                <p className='ma0'>File selected</p>
              </div>
            </div>
          </div>
          <div className='flex' role="menu" aria-label={'menuOptions'} ref={ this.containerRef } tabIndex="0">
            <Link to='/send' className='charcoal' >
              <Route>
                <Route path="/send" component={SendPage} />
              </Route>
              <button role="menuitem" className={classNames('tc mh2', classes.action(isSingle))} onClick={isSingle ? send : null} {...singleFileTooltip}>
                <StrokeSend className={classes.svg(isSingle)} fill='#A4BFCC' aria-hidden="true"/>
                <p className='ma0 f6'>Send</p>
              </button>
            </Link>
            <button role="menuitem" className={classNames('tc mh2')} onClick={cancel} {...singleFileTooltip} disabled={multipleCanceling}>
              <StrokeCancel className='w3 hover-fill-navy-muted' fill='#A4BFCC' aria-hidden="true"/>
              <p className='ma0 f6'>Cancel</p>
            </button>
          </div>
          <div>
            <button onClick={unselect} className='flex items-center justify-end f6 charcoal'>
              <span className='mr2 db-m'>Unselect All</span>
              <GlyphSmallCancel onClick={unselect} className='fill-charcoal w1 o-70' viewBox='37 40 27 27' />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    multipleCanceling: state.token.multipleCanceling
  };
};

export default connect(mapStateToProps)(SelectedActions);
